define((require) => {
    "use strict";

    const _                          = require("underscore");
    const Backbone                   = require("backbone");
    const ImageDetailsView           = require("ui/imageLibrary/ImageDetailsView");
    const ImageExperienceCollection  = require("ui/imageLibrary/ImageExperienceCollection");
    const ImageLibraryCollectionView = require("ui/imageLibrary/ImageLibraryCollectionView");
    const ImageModel                 = require("ui/assets/image/ImageModel");
    const ImageDetailsLightbox       = require("ui/imageLibrary/ImageDetailsLightbox");
    const Preconditions              = require("shared/util/Preconditions");

    /**
     * A `ImageLibraryCollectionView` that will show a "Image Quickview" when the image thumbnail is clicked.
     *
     * Used by the main image dashboard and the project dashboard.
     *
     * @see DashboardImageLibraryView
     * @see ProjectDashboardImageLibrary
     *
     * @class DetailedImageLibraryCollectionView
     */
    return ImageLibraryCollectionView.extend("DetailedImageLibraryCollectionView", {

        className: `${ImageLibraryCollectionView.prototype.className} detailed`,

        _lightBox: null,

        _partialViewOptions: null,

        constructor(options = {}) {
            const collectionViewOptions = options.collectionViewOptions = options.collectionViewOptions || {};
            const itemEvents = collectionViewOptions.itemEvents = collectionViewOptions.itemEvents || {};
            this._partialViewOptions = options.partialViewOptions;

            itemEvents["image:clicked"] = (model) => this._imageClickedHandler(model);

            this.__super(options);

            this._loadSelectedDetails();
        },

        _imageClickedHandler(model) {
            const id = model.id;
            this._showDetailsView(model);

            this._partialViewOptions = _.extend(this._partialViewOptions || {}, {id, showExperiences: false});
            this._updateRoute(`images/details/${id}`);
        },

        /**
         * Updates partial views with the specified view options from the editor router
         *
         * @param {Object} partialViewOptions Options for partial views (i.e. image details view)
         * @property {String} id Image id
         * @property {Boolean} showExperiences True if experiences should be displayed
         */
        updatePartialViews(partialViewOptions) {
            this._partialViewOptions = partialViewOptions;
            this._loadSelectedDetails();
        },

        /**
         * Loads the image detail based on the current partial view details
         */
        _loadSelectedDetails() {
            this._closeLightBox();

            if (this._partialViewOptions) {
                ImageModel.findById(this._partialViewOptions.id).then((model) => {
                    this._showDetailsView(model);
                });
            }
        },

        _updateRoute(route) {
            if (this.options.project) {
                route = `project/${this.options.project.id}/${route}`;
            }

            Backbone.history.navigate(route);
        },

        _showDetailsView(model) {
            const experienceCollection = new ImageExperienceCollection({imageId: model.id});

            experienceCollection.count().then((experienceCount) => {
                const imagedetailsView = new ImageDetailsView(_.extend(this.options, {
                    partialViewOptions: this._partialViewOptions,
                    model,
                    experienceCollection,
                    experienceCount
                }));

                this._lightBox = new ImageDetailsLightbox(imagedetailsView, {css: {width: 540}});

                this._lightBox.open();

                this.listenTo(this._lightBox, "close", () => {
                    this.stopListening(imagedetailsView);
                    this._updateRoute("images");
                });

                this.listenTo(imagedetailsView, "toggled:experiences", this._toggledExperiences);
                this.listenTo(imagedetailsView, "edit:experience", this._editExperience);
            }).fail(() => {
                Preconditions.fail(`Cannot load experience count for image, id: '${model.id}'`);
            });
        },

        _closeLightBox() {
            if (this._lightBox) {
                // Avoid triggering the close event
                this._lightBox.close({silent: true});
            }
        },

        _toggledExperiences(model, isOpen) {
            if (!isOpen) {
                this._updateRoute(`images/details/${model.id}/experiences`);
            } else {
                this._updateRoute(`images/details/${model.id}`);
            }
        },

        _editExperience() {
            this._closeLightBox();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/DetailedImageLibraryCollectionView.js